import { FC, ReactNode } from 'react';
import { Dialog as MuiDialog, DialogContent, DialogTitle } from '@mui/material';
import { Dialogs } from '../constants/dialogs';
import { useDialog } from '../contexts/dialog.context.tsx';

export interface DialogProps {
  children: ReactNode;
  dialog: Dialogs;
  title: string;
}

export const Dialog: FC<DialogProps> = ({ dialog, title, children }) => {
  const { openedDialog, closeDialog } = useDialog();
  return (
    <MuiDialog open={dialog === openedDialog} onClose={() => closeDialog()}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
    </MuiDialog>
  );
};
